module.exports = __webpack_public_path__ + "static/media/guidePage_trade.ea2971b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/guidePage_trade.png
// module id = 772
// module chunks = 0 1